var validateTextField = require('../common/validate-textfield');

window.iq = window.iq || {};

module.exports = {
	init: function () {
		if (window.jQuery('#express-reg-form').length > 0) {
			window.jQuery('#express-reg-form').on('submit', function (e) {
				var error = false;

				if (window.jQuery('#password').val() !== window.jQuery('#confirmPassword').val()) {
					window.jQuery('#confirmPassword').closest('.errorContainer').addClass('error');
					error = true;
				} else {
					window.jQuery('#confirmPassword').closest('.errorContainer').removeClass('error');
				}

				error = validateTextField('#password') || error;
				error =
					validateTextField('#confirmPassword', '.errorContainer', '.error', window.jQuery('#password').val()) || error;

				if (error) {
					e.preventDefault();
					return false;
				}
				return true;
			});
		}
	}
};
